import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'betaLabel'
	| 'closeButton'
	| 'memoriesHeading'
	| 'settingsUpdateSuccessTitle'
	| 'settingsUpdateErrorTitle'
	| 'memoryDeleteSuccessTitle'
	| 'memoryDeleteErrorTitle'
	| 'viewAllMemories'
	| 'webSearchPreferenceLabel'
	| 'webSearchPreferenceDescription';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	betaLabel: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.beta-label',
		defaultMessage: 'Beta',
		description: 'Beta lozenge label shown next to the memory section title',
	},
	closeButton: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.close-button',
		defaultMessage: 'Close',
		description: 'Label for the close button in the manage memory modal',
	},
	memoriesHeading: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.memories-heading',
		defaultMessage: 'Memories',
		description: 'Heading for the memories list section in the manage memory modal',
	},
	settingsUpdateSuccessTitle: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.settings-update-success-title',
		defaultMessage: 'Memory settings updated. Your preference has been saved.',
		description: 'Title for the success flag shown after a settings update',
	},
	settingsUpdateErrorTitle: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.settings-update-error-title',
		defaultMessage:
			"We couldn't update your memory settings. Something went wrong. Please try again.",
		description: 'Title for the error flag shown when a settings update fails',
	},
	memoryDeleteSuccessTitle: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.memory-delete-success-title',
		defaultMessage: 'Memory successfully removed.',
		description: 'Title for the success flag shown after a memory is deleted',
	},
	memoryDeleteErrorTitle: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.memory-delete-error-title',
		defaultMessage: "We couldn't delete this memory. Something went wrong. Please try again.",
		description: 'Title for the error flag shown when a memory deletion fails',
	},
	viewAllMemories: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.view-all-memories',
		defaultMessage: 'View all memories',
		description: 'Button label to open a subscreen showing all memories',
	},
	webSearchPreferenceLabel: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.web-search-preference.label',
		defaultMessage: 'Web search',
		description: 'Label for the toggle that controls whether web search is enabled by default',
	},
	webSearchPreferenceDescription: {
		id: 'ai-mate.rovo-memories.manage-memory-modal.web-search-preference.description',
		defaultMessage: 'When enabled, Rovo will search the web to provide more up-to-date answers.',
		description: 'Description for the web search default setting',
	},
});
